import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'PROCEDURESTEP_SHOW_ERROR':
      return action.error;

    case 'PROCEDURESTEP_SHOW_MERCURE_DELETED':
      return `${action.retrieved['@id']} has been deleted by another user.`;

    case 'PROCEDURESTEP_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'PROCEDURESTEP_SHOW_LOADING':
      return action.loading;

    case 'PROCEDURESTEP_SHOW_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'PROCEDURESTEP_SHOW_SUCCESS':
    case 'PROCEDURESTEP_SHOW_MERCURE_MESSAGE':
      return action.retrieved;

    case 'PROCEDURESTEP_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export function eventSource(state = null, action) {
  switch (action.type) {
    case 'PROCEDURESTEP_SHOW_MERCURE_OPEN':
      return action.eventSource;

    case 'PROCEDURESTEP_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved, eventSource });
